declare var require: any;

export const globalConst = {
  version: require("../../../../package.json").version,
  systemTitle: "Portal de Abertura de O.S",

  company: {
    name: "Sabara Químicos e Ingredientes",
    initialYearCopy: "2020",
    endYearCopy: "2020",
    phone: "+ 55 81 3543 7900",
    site: "https://www.sabaraquimicos.com/",
    address: {
      street: "BR 101 Norte",
      number: "Km 38",
      district: "Distrito Industrial",
      city: "Itapissuma",
      state: "PE",
      postalCode: "53700-000",
    },
  },

  swal: {
    swalSuccess: "success",
    swalError: "error",
    swalWarning: "warning",
    swalInfo: "info",
    swalQuestion: "question",
    swalTitleSuccess: "Sucesso!",
    swalTitleError: "Erro!",
  },

  router: {
    home: "/home",
    login: "/login",
    changePassword: "/user/pass",
  },

  localStorage: {
    userLogged: "user",
    tokenName: "ZXN0ZcOpb3Rva2VuZG9zYWJhcmE=",
    environment: "environment",
  },

  pagination: {
    itemsPerPage: 5,
    itemsPerPageDefault: 10,
    pagesToShowDafault: 10,
    itemsToShow: [5, 10, 25, 50, 100],
  },

  form: {
    requiredField: "Campo Obrigátorio",
  },

  auth: {
    tokenExpired: "Sua sessão expirou, por favor faça o login novamente",
    directLoginError:
      "Aconteceu um erro ao acessar o sistema por favor entre em contato com o TI",
  },

  messages: {
    LoginRecoveryPasswordFormInvalid:
      "Para resetar a senha, informe seu usuário",
    loginRecoveryPasswordSuccessTitle:
      "<span style='color: red'>Senha redefinida para senha padrão</span>",
    // tslint:disable-next-line:max-line-length
    loginRecoveryPasswordError:
      "Ocorreu um erro ao redefinir sua senha, tente novamente mais tarde ou contacte um administrador do sistema",
    emptySearch: "Nenhum registro localizado com o filtro informado",

    errorSave: "Ocorreu algum erro ao efetuar o cadastro",
    errorLoadingServiceRequests:
      "Ocorreu algum erro ao carregar as solicitações",
  },

  options: {
    serviceRequestStatus: ["A", "L", "R"],
    userTypes: [
      { value: "A", viewValue: "Administrador" },
      { value: "T", viewValue: "Técnico" },
      { value: "C", viewValue: "Cliente" },
    ],
  },

  defaults: {
    user: {
      admin: "A",
      tecnical: "T",
      client: "C",
    },
    situation: {
      waiting: { id: "30", text: "Aguardando Envio" },
      sended: { id: "40", text: "Em campo" },
      returned: { id: "50", text: "Retornada de Campo" },
      canceled: { id: "70", text: "Cancelada" },
    },
  },

  attachment: {
    max: 3,
  },
};
